module.exports = __webpack_public_path__ + "img/20210906-1630913521394096.13dafc2a.png";